import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { ProfileQueryKey } from './queryKey';
export var useUpdateProfile = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base
            .put('/api/employee/profile', model)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (result) {
                var dataCache = DataCacheService.getDataCache();
                if (dataCache) {
                    dataCache.employee = result;
                }
                queryClient.setQueryData([ProfileQueryKey.Profile], result);
            }
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateProfile: mutateAsync, isLoading: isLoading };
};
